import React, { createRef } from 'react';
import styled from 'styled-components';
import {
  Row,
  Col,
  Button,
  PageHeader,
  Badge,
  Table,
  Input,
  Modal,
  Select,
  Spin,
  Divider,
  FloatButton,
  Tooltip,
  Card,
  Typography,
  Tabs,
  InputNumber,
  Upload,
  Collapse,
  ColorPicker,
  DatePicker,
  Tag,
  Rate,
  Radio,
  message
} from 'antd';
import { QRCodeCanvas } from 'qrcode.react';
import {
  CloseCircleFilled,
  CheckOutlined,
  CloseOutlined,
  BellOutlined,
  TeamOutlined,
  PlusCircleOutlined,
  PlusCircleFilled,
  CheckCircleOutlined,
  StopFilled,
  CloseCircleOutlined,
  RocketFilled,
  SearchOutlined,
  DeleteFilled,
  PlusOutlined,
  CaretRightOutlined,
  RightCircleFilled,
  CommentOutlined,
  CustomerServiceOutlined,
  SwapRightOutlined,
  InfoCircleFilled,
  EditFilled,
  QrcodeOutlined,
  DownloadOutlined
} from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import { resolveSelectedSite } from 'src/utils/selectedSite';
import {
  DEFAULT_STAR_COUNT,
  criteriaWithHistory,
  isNA,
  isScored,
  naValueFor,
  resolveSiteCriteria,
  resolveStarCount,
  scaleOfRecord,
  toPercent
} from 'src/constants/experienceCriteria';
import { withIsMobile } from 'src/utils/responsive';
import Notify from 'src/components/meta/Notification';
import Highlighter from 'react-highlight-words';
import Resizer from 'react-image-file-resizer';
import slugify from 'slugify';
import dayjs from 'dayjs';
import { deleteExperience } from 'src/redux/actions/experience';
import XLSX from 'sheetjs-style';
import { saveAs } from 'file-saver';
const { Title } = Typography;
const { Column } = Table;
const FormItem = Form.Item;

const { TabPane } = Tabs;
const { TextArea } = Input;
const { Option } = Select;

const ResponsiveFormWrap = styled.span`
  @media (max-width: 991px) {
    display: block;
    width: 100%;
    min-width: 0;

    .ant-col {
      flex: 0 0 100% !important;
      max-width: 100% !important;
      margin-top: 0 !important;
    }
    .ant-row {
      margin-left: 0 !important;
      margin-right: 0 !important;
      padding-left: 1em !important;
      padding-right: 1em !important;
    }
    .ant-form-item {
      margin-bottom: 1em;
    }
    .ant-input,
    .ant-input-number,
    .ant-picker,
    .ant-select {
      width: 100% !important;
      max-width: 100% !important;
    }
    .ant-input,
    .ant-input-number,
    .ant-picker,
    .ant-select-selector {
      min-height: 44px !important;
      border-radius: 8px !important;
    }
    .ant-input,
    .ant-picker-input > input,
    .ant-input-number-input,
    .ant-select-selection-item,
    .ant-select-selection-placeholder {
      font-size: 16px !important;
    }
    textarea.ant-input {
      min-height: 96px !important;
    }
    .ant-form-item-label {
      padding-bottom: 0.3em;
    }
    .ant-form-item-label > label {
      height: auto;
      white-space: normal;
      line-height: 1.3;
    }
    .experience-primary-fields,
    .experience-date-fields {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 0.65em;
    }
    .experience-primary-fields .ant-col,
    .experience-date-fields .ant-col {
      min-width: 0;
    }
    .experience-rating-grid {
      display: grid;
      grid-template-columns: 1fr;
      gap: 0.7em;
      padding-top: 1em !important;
    }
    .experience-rating-grid > .ant-col {
      padding: 0.85em !important;
      border: 1px solid #e1e9e3;
      border-radius: 10px;
      background: #fbfdfb;
      box-shadow: 0 3px 10px rgba(31, 61, 38, 0.04);
    }
    .experience-rating-grid .ant-form-item {
      margin-bottom: 0;
    }
    .rating-with-na {
      justify-content: space-between;
      gap: 0.5em !important;
    }
    .rating-with-na .ant-rate {
      font-size: 21px;
      white-space: nowrap;
    }
    .rating-with-na .ant-btn {
      min-height: 36px;
    }
    .experience-recommendation {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      width: 100%;
    }
    .experience-recommendation .ant-radio-button-wrapper {
      padding: 0 0.4em;
      text-align: center;
    }
  }

  @media (max-width: 599px) {
    .experience-primary-fields,
    .experience-date-fields {
      grid-template-columns: 1fr;
      gap: 0;
    }
  }
`;
const StyledTable = styled(Table)`
  @media (max-width: 991px) {
    .ant-table-content,
    .ant-table-body {
      overflow-x: auto !important;
      -webkit-overflow-scrolling: touch;
      touch-action: pan-x pan-y;
      scrollbar-width: thin;
      scrollbar-color: #80ce90 #eef2ef;
    }
    .ant-table-content::-webkit-scrollbar,
    .ant-table-body::-webkit-scrollbar {
      height: 8px;
    }
    .ant-table-content::-webkit-scrollbar-track,
    .ant-table-body::-webkit-scrollbar-track {
      background: #eef2ef;
      border-radius: 999px;
    }
    .ant-table-content::-webkit-scrollbar-thumb,
    .ant-table-body::-webkit-scrollbar-thumb {
      background: #80ce90;
      border-radius: 999px;
    }
    .ant-table table {
      min-width: 40em;
    }
    .ant-table-thead > tr > th {
      white-space: nowrap;
      padding: 10px 12px;
      background: #fafafa !important;
      color: #262626 !important;
      font-size: 12px;
      font-weight: 700;
    }
    .ant-table-cell-fix-right {
      background: #fff;
      z-index: 4;
      box-shadow: -5px 0 10px rgba(0, 0, 0, 0.06);
    }
    .ant-table-thead .ant-table-cell-fix-right {
      background: #fafafa !important;
      z-index: 6;
    }
    .ant-table-container {
      overflow: hidden;
      border: 1px solid #e3ebe5;
      border-radius: 12px;
      background: #fff;
      box-shadow: 0 4px 14px rgba(31, 61, 38, 0.06);
    }
    .ant-table-tbody > tr > td {
      padding: 10px 12px;
      font-size: 13px;
      line-height: 1.35;
    }
    .ant-table-tbody > tr:nth-child(even):not(.ant-table-expanded-row) > td {
      background: #fbfcfb;
    }
    .ant-table-expanded-row > td {
      padding: 8px !important;
      background: #f2f5f3 !important;
    }
    .ant-table-expanded-row .ant-table-wrapper {
      margin: 0 !important;
    }
    .ant-table-tbody .ant-table-cell-fix-right .anticon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 36px;
      min-height: 36px;
    }
    .ant-table-row-expand-icon {
      width: 30px !important;
      height: 30px !important;
      min-width: 30px;
      min-height: 30px;
      border: 1px solid rgba(128, 206, 144, 0.65) !important;
      border-radius: 50% !important;
      background: #f3fff6 !important;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
      cursor: pointer;
    }
    .ant-table-row-expand-icon::before {
      top: 13px !important;
      right: 7px !important;
      left: 7px !important;
      height: 2px !important;
      background: #80ce90 !important;
    }
    .ant-table-row-expand-icon::after {
      top: 7px !important;
      bottom: 7px !important;
      left: 13px !important;
      width: 2px !important;
      background: #80ce90 !important;
    }
    .ant-table-row-expand-icon-cell {
      position: sticky !important;
      left: 0;
      width: 48px;
      min-width: 48px;
      max-width: 48px;
      padding: 8px !important;
      z-index: 5;
      background: #fff !important;
    }
    .ant-table-thead > tr > .ant-table-row-expand-icon-cell {
      background: #fafafa !important;
      z-index: 7;
    }
    .ant-table-thead > tr > .ant-table-row-expand-icon-cell + th,
    .ant-table-tbody > tr > .ant-table-row-expand-icon-cell + td {
      position: sticky !important;
      left: 48px;
      z-index: 4;
      background: #fff !important;
      box-shadow: 5px 0 10px rgba(0, 0, 0, 0.05);
    }
    .ant-table-thead > tr > .ant-table-row-expand-icon-cell + th {
      background: #fafafa !important;
      color: #262626 !important;
      z-index: 6;
    }
    .ant-table-thead
      > tr
      > th:first-child:not(.ant-table-row-expand-icon-cell),
    .ant-table-tbody
      > tr:not(.ant-table-expanded-row)
      > td:first-child:not(.ant-table-row-expand-icon-cell) {
      position: sticky !important;
      left: 0;
      z-index: 4;
      background: #fff !important;
      box-shadow: 5px 0 10px rgba(0, 0, 0, 0.05);
    }
    .ant-table-thead
      > tr
      > th:first-child:not(.ant-table-row-expand-icon-cell) {
      background: #fafafa !important;
      z-index: 6;
    }
    .ant-pagination {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      row-gap: 0.5em;
    }
  }
`;
const Cards = styled(Card)`
  :where(.css-dev-only-do-not-override-133wgew).ant-card .ant-card-body {
    padding-left: 0px !important;
    padding-bottom: 3em !important;
  }

  @media (max-width: 991px) {
    width: 100%;
    min-width: 0;
    margin-bottom: 1em;

    > .ant-card-head {
      min-height: auto;
      padding: 0.9em 1em;
      border-bottom: 1px solid #edf1ee;
    }
    .ant-card-head-wrapper {
      flex-wrap: wrap;
      gap: 0.5em;
    }
    .ant-card-extra {
      width: 100%;
      margin-left: 0;
    }
    > .ant-card-body {
      padding: 1em !important;
      padding-bottom: 6em !important;
    }
  }
`;
const MobileEditActions = styled.div`
  display: none;

  @media (max-width: 991px) {
    position: fixed;
    right: 1em;
    bottom: 0.5em;
    bottom: calc(0.5em + env(safe-area-inset-bottom));
    left: 1em;
    z-index: 50;
    display: flex;
    gap: 0.65em;
    padding: 0.65em;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 0.8em;
    background: rgba(255, 255, 255, 0.94);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.14);
    backdrop-filter: blur(8px);

    .ant-btn {
      flex: 1 1 0;
      height: 44px;
      border-radius: 0.65em;
      font-weight: 700;
    }
  }
`;
const ExperienceToolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.7em;
  flex-direction: row-reverse;

  @media (max-width: 991px) {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.55em;

    .experience-add {
      grid-column: 1 / -1;
      order: 1;
    }
    .experience-export,
    .experience-qr {
      order: 2;
    }
    .experience-site {
      grid-column: 1 / -1;
      order: 3;
    }
    .experience-month,
    .experience-year {
      order: 4;
    }
    .experience-add,
    .experience-export,
    .experience-qr {
      width: 100% !important;
      min-width: 0;
      height: 44px;
      margin-top: 0 !important;
    }
    .ant-picker,
    .ant-select {
      width: 100% !important;
      min-width: 0;
    }
  }
`;
const ExperienceAverages = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5em;
  margin-top: 1em;

  .ant-tag {
    margin: 0;
  }

  @media (max-width: 991px) {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));

    .ant-tag {
      width: 100%;
      padding: 0.55em !important;
      overflow: hidden;
      font-size: 11px !important;
      text-align: center;
      text-overflow: ellipsis;
    }
  }
`;
const MobileTableHelp = styled.div`
  display: none;

  @media (max-width: 991px) {
    display: flex;
    align-items: center;
    gap: 0.55em;
    margin-top: 1em;
    padding: 0.65em 0.8em;
    border: 1px solid rgba(128, 206, 144, 0.45);
    border-radius: 10px;
    background: #f3faf5;
    color: #42624a;
    font-size: 12px;

    strong {
      flex: 0 0 auto;
      padding: 0.25em 0.45em;
      border-radius: 5px;
      background: #dff2e3;
      color: #2f7e43;
      font-size: 10px;
      letter-spacing: 0.04em;
    }
  }
`;
const StyledTabs = styled(Tabs)`
  .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab,
  .ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab {
    padding: 11px 19px !important;
    background-color: red !important;
  }
`;
const StyledInputNumber = styled(InputNumber)`
  font-weight: 500 !important;
  color: #525f7f !important;
  font-size: 15px !important;
  cursor: not-allowed;
  .ant-input-number-disabled .ant-input-number-input {
    font-weight: 500 !important;
    color: #525f7f !important;
    font-size: 15px !important;
    cursor: not-allowed;
  }
`;
const Selection = styled(Select)`
  .ant-select-selection {
    border: 1px solid #bdb2b2;
    height: 45px;
    font-size: 12px;
  }
  .ant-select-selection__placeholder {
    top: 21px;
  }
  .ant-select-selection__rendered {
    height: 44px;
  }
  .ant-select-selection-selected-value {
    position: relative;
    top: 6px;
  }
`;
const StyledBadge = styled(Badge)`
  .ant-badge-status-dot {
    height: 0.6em !important;
    width: 0.6em !important;
  }
`;

// Tooltips only make sense for the historical 4-point scale; on any other
// scale the numbers speak for themselves.
const FOUR_POINT_TOOLTIPS = ['Poor', 'Fair', 'Good', 'Excellent'];

const RatingWithNA = ({ value, onChange, scale = DEFAULT_STAR_COUNT }) => {
  const naValue = naValueFor(scale);
  const isNa = Number(value) === naValue;

  return (
    <div
      className="rating-with-na"
      style={{ display: 'flex', alignItems: 'center', gap: '0.75em', flexWrap: 'wrap' }}
    >
      <Rate
        count={scale}
        value={isNa ? 0 : value || 0}
        onChange={val => onChange(val || 0)}
        tooltips={scale === 4 ? FOUR_POINT_TOOLTIPS : undefined}
      />
      <Button
        size="small"
        type={isNa ? 'primary' : 'default'}
        style={{ borderRadius: '2em', fontWeight: 600, minWidth: '3.5em' }}
        onClick={() => onChange(isNa ? 0 : naValue)}
      >
        N/A
      </Button>
    </div>
  );
};

function callback(key) {
  console.log(key);
}
const children = [];
for (let i = 10; i < 36; i++) {
  children.push(<Option key={i.toString(36) + i}>{i.toString(36) + i}</Option>);
}

function handleChange(value) {
  console.log(`selected ${value}`);
}
class ExperienceFormClass extends React.Component {
  state = {
    descriptions: this.props.descriptions,
    mainExperienceImage1: undefined
  };

  // The card belongs to the site it was captured for, which is not necessarily
  // the site currently selected on the page.
  cardSite = () => {
    const access =
      (this.props.editExperience && this.props.editExperience.access) ||
      this.props.siteSelected;
    return (this.props.sites || []).find(
      site => String(site._id) === String(access)
    );
  };

  // An existing card is scored on the scale it was captured with; a new one
  // uses whatever the site is configured for now.
  editCardScale = () =>
    this.props.editExperience
      ? scaleOfRecord(this.props.editExperience)
      : resolveStarCount(this.cardSite());

  // Show the site's current questions, plus any this particular card was
  // answered against, so editing an older card doesn't drop its scores.
  editCardCriteria = () =>
    this.props.editExperience
      ? criteriaWithHistory(this.cardSite(), [this.props.editExperience])
      : resolveSiteCriteria(this.cardSite()).map(c => ({
          ...c,
          retired: false
        }));
  componentDidMount = () => {
    if (this.props.editExperience) {
      this.setState({
        mainExperienceImage1: this.props.editExperience.mainExperienceImage1
      });
    }
  };

  handleMainExperienceImage1 = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        mainExperienceImage1: imageUrl
      });
    });
  };
  handleImageUpload = ({ onSuccess, file }) => {
    onSuccess(true, file);
  };
  beforeUpload = file => {
    const isLt2M = file.size / 1024 / 1024 < 4;
    if (!isLt2M) {
      Notify('error', window.i18n.translate('ImageSmaller'));
    }
    return false;
  };
  getBase64 = (img, callback) => {
    Resizer.imageFileResizer(img, 1000, 1000, 'JPG', 100, 0, uri => {
      callback(uri);
    });
  };
  selectItem = value => {
    if (value.substr(0, 4) === 'Add ') {
      let parsedValue = value.substr(4, value.length);
      this.props.form.setFieldsValue({ description: parsedValue });
      let descriptions = this.state.descriptions;
      descriptions.pop();
      descriptions.push({ value: parsedValue });
      this.setState({ descriptions: descriptions });
    }
  };
  searchItem = (value, b) => {
    let descriptions = this.state.descriptions;
    if (descriptions[descriptions.length - 1].value.substr(0, 4) === 'Add ') {
      descriptions.pop();
    }
    if (
      !descriptions.find(
        descriptions => descriptions.value.toLowerCase() === value.toLowerCase()
      ) &&
      value !== ''
    ) {
      descriptions.push({ value: 'Add ' + value });
    }
    this.setState({ descriptions: descriptions });
  };
  render() {
    return (
      <ResponsiveFormWrap>
      <Form layout="vertical">
        <Row
          gutter={24}
          style={{ padding: '3em', paddingTop: '0em', paddingBottom: '0em' }}
        >
          {/* Timestamp */}
          <Col span={6}>
            <FormItem label={<span>Timestamp</span>}>
              {this.props.form.getFieldDecorator('timestamp', {
                initialValue: this.props.editExperience
                  ? dayjs(this.props.editExperience.timestamp)
                  : undefined
              })(
                <DatePicker
                  style={{ width: '100%' }}
                  placeholder="Timestamp"
                  size="large"
                />
              )}
            </FormItem>
          </Col>

          {/* Score */}
          {/* <Col span={6}>
            <FormItem label="Score">
              {this.props.form.getFieldDecorator("score", {
                initialValue: this.props.editExperience
                  ? this.props.editExperience.score
                  : null,
                rules: [{ required: true, message: "Score is required" }],
              })(
                <InputNumber
                  min={0}
                  max={10}
                  style={{ width: "100%" }}
                  placeholder="Enter a score out of 10"
                  size="large"
                />
              )}
            </FormItem>
          </Col> */}
          <Col span={6} style={{ display: 'none' }}>
            {' '}
            <FormItem label={<span>Assign To</span>}>
              {this.props.form.getFieldDecorator('access', {
                initialValue: this.props.editExperience
                  ? this.props.editExperience.access
                  : this.props.siteSelected
              })(
                <Select
                  size="large"
                  // mode="multiple"
                  showSearch
                >
                  {/* <Option key="Admin" value="Admin">
                  Admin
                </Option> */}
                  {this.props.sites.map(site => (
                    <Option key={site._id} value={site._id}>
                      {site.name}
                      {/* {site.name} ({site._id}) */}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>
          </Col>
        </Row>

        <Row
          className="experience-primary-fields"
          gutter={24}
          style={{ padding: '3em', paddingTop: '1em', paddingBottom: '0em' }}
        >
          {/* Email */}
          <Col span={6}>
            <FormItem label="Email">
              {this.props.form.getFieldDecorator('email', {
                initialValue: this.props.editExperience
                  ? this.props.editExperience.email
                  : '',
                rules: [{ required: true, message: 'Email is required' }]
              })(
                <Input
                  type="email"
                  placeholder="Enter your email"
                  size="large"
                />
              )}
            </FormItem>
          </Col>

          {/* Full Name */}
          <Col xs={24} md={6}>
            <FormItem
              hasFeedback
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Name"
            >
              {this.props.form.getFieldDecorator('firstName', {
                initialValue: this.props.editExperience
                  ? this.props.editExperience.firstName
                  : '',
                rules: [{ required: true, message: 'Name is required' }]
              })(<Input placeholder="Enter your full name" size="large" />)}
            </FormItem>
          </Col>
          <Col xs={24} md={6}>
            <FormItem
              hasFeedback
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Last Name"
            >
              {this.props.form.getFieldDecorator('lastName', {
                initialValue: this.props.editExperience
                  ? this.props.editExperience.lastName
                  : '',
                rules: [{ required: true, message: 'Last name is required' }]
              })(<Input placeholder="Enter your last name" size="large" />)}
            </FormItem>
          </Col>

          {/* Room Number */}
          <Col span={6}>
            <FormItem label="Room Name/Number">
              {this.props.form.getFieldDecorator('roomNumber', {
                initialValue: this.props.editExperience
                  ? this.props.editExperience.roomNumber
                  : '',
                rules: [{ required: true, message: 'Room is required' }]
              })(<Input placeholder="Enter your room name or number" size="large" />)}
            </FormItem>
          </Col>
        </Row>

        <Row
          className="experience-date-fields"
          gutter={24}
          style={{
            padding: '3em',
            paddingTop: '1em',
            paddingBottom: '0em',
            borderTop: '1px dashed #d9d9d9',
            marginTop: '2em'
          }}
        >
          {/* Arrival Date */}
          <Col span={6}>
            <FormItem label="Arrival Date">
              {this.props.form.getFieldDecorator('arrivalDate', {
                initialValue: this.props.editExperience
                  ? dayjs(this.props.editExperience.arrivalDate)
                  : null,
                rules: [{ required: true, message: 'Arrival date is required' }]
              })(<DatePicker style={{ width: '100%' }} size="large" />)}
            </FormItem>
          </Col>

          {/* Departure Date */}
          <Col span={6}>
            <FormItem label="Departure Date">
              {this.props.form.getFieldDecorator('departureDate', {
                initialValue: this.props.editExperience
                  ? dayjs(this.props.editExperience.departureDate)
                  : null,
                rules: [
                  { required: true, message: 'Departure date is required' }
                ]
              })(<DatePicker style={{ width: '100%' }} size="large" />)}
            </FormItem>
          </Col>
        </Row>

        {/* Ratings Section */}
        <Row
          className="experience-rating-grid"
          gutter={24}
          style={{
            padding: '3em',
            paddingTop: '0em',
            paddingBottom: '0em',
            borderTop: '1px dashed #d9d9d9',
            marginTop: '2em'
          }}
        >
          {this.editCardCriteria().map(rating => (
            <Col span={6} key={rating.key} style={{ marginTop: '1em' }}>
              <FormItem
                label={
                  rating.retired ? `${rating.label} (retired)` : rating.label
                }
              >
                {this.props.form.getFieldDecorator(rating.key, {
                  initialValue: this.props.editExperience
                    ? this.props.editExperience[rating.key]
                    : 0,
                  rules: [{ required: false }]
                })(<RatingWithNA scale={this.editCardScale()} />)}
              </FormItem>
            </Col>
          ))}
        </Row>

        {/* Text Feedback Section */}
        <Row
          gutter={24}
          style={{
            padding: '3em',
            paddingTop: '1em',
            paddingBottom: '2em',
            borderTop: '1px dashed #d9d9d9',
            marginTop: '2em'
          }}
        >
          <Col span={24} style={{ marginTop: '0.5em' }}>
            <FormItem label="Most Memorable Part of Your Stay">
              {this.props.form.getFieldDecorator('memorablePart', {
                initialValue: this.props.editExperience
                  ? this.props.editExperience.memorablePart
                  : '',
                rules: [{ required: false }]
              })(
                <TextArea
                  placeholder="Describe the most memorable part of your stay"
                  rows={3}
                />
              )}
            </FormItem>
          </Col>
          <Col span={24} style={{ marginTop: '1em' }}>
            <FormItem label="Team Member Who Delivered Outstanding">
              {this.props.form.getFieldDecorator('outstandingService', {
                initialValue: this.props.editExperience
                  ? this.props.editExperience.outstandingService
                  : '',
                rules: [{ required: false }]
              })(<TextArea placeholder="Name the team member" rows={2} />)}
            </FormItem>
          </Col>
          <Col span={24} style={{ marginTop: '1em' }}>
            <FormItem label="Would You Recommend Us to Family and Friends?">
              {this.props.form.getFieldDecorator('recommendation', {
                initialValue: this.props.editExperience
                  ? this.props.editExperience.recommendation
                  : null,
                rules: [{ required: false, message: 'Please select an option' }]
              })(
                <Radio.Group
                  className="experience-recommendation"
                  buttonStyle="solid"
                  size="large"
                >
                  <Radio.Button value="Yes">Yes</Radio.Button>
                  <Radio.Button value="No">No</Radio.Button>
                  <Radio.Button value="Maybe">Maybe</Radio.Button>
                </Radio.Group>
              )}
            </FormItem>
          </Col>
          <Col span={24} style={{ marginTop: '1em' }}>
            <FormItem label="Comments">
              {this.props.form.getFieldDecorator('comments', {
                initialValue: this.props.editExperience
                  ? this.props.editExperience.comments
                  : '',
                rules: [{ required: false }]
              })(
                <TextArea
                  placeholder="Enter any additional comments"
                  rows={3}
                />
              )}
            </FormItem>
          </Col>
        </Row>
      </Form>
      </ResponsiveFormWrap>
    );
  }
}
const ExperienceForm = Form.create()(ExperienceFormClass);
class SliderFormClass extends React.Component {
  state = {
    descriptions: this.props.descriptions,
    mainExperienceImage1: undefined
  };
  componentDidMount = () => {
    if (this.props.editExperience) {
      this.setState({
        mainExperienceImage1: this.props.editExperience.mainExperienceImage1
      });
    }
  };

  handleMainExperienceImage1 = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        mainExperienceImage1: imageUrl
      });
    });
  };
  handleImageUpload = ({ onSuccess, file }) => {
    onSuccess(true, file);
  };
  beforeUpload = file => {
    const isLt2M = file.size / 1024 / 1024 < 4;
    if (!isLt2M) {
      Notify('error', window.i18n.translate('ImageSmaller'));
    }
    return false;
  };
  getBase64 = (img, callback) => {
    Resizer.imageFileResizer(img, 1000, 1000, 'JPG', 100, 0, uri => {
      callback(uri);
    });
  };
  selectItem = value => {
    if (value.substr(0, 4) === 'Add ') {
      let parsedValue = value.substr(4, value.length);
      this.props.form.setFieldsValue({ description: parsedValue });
      let descriptions = this.state.descriptions;
      descriptions.pop();
      descriptions.push({ value: parsedValue });
      this.setState({ descriptions: descriptions });
    }
  };
  searchItem = (value, b) => {
    let descriptions = this.state.descriptions;
    if (descriptions[descriptions.length - 1].value.substr(0, 4) === 'Add ') {
      descriptions.pop();
    }
    if (
      !descriptions.find(
        descriptions => descriptions.value.toLowerCase() === value.toLowerCase()
      ) &&
      value !== ''
    ) {
      descriptions.push({ value: 'Add ' + value });
    }
    this.setState({ descriptions: descriptions });
  };
  render() {
    return (
      <ResponsiveFormWrap>
      <Form layout="vertical">
        <Row
          gutter={24}
          style={{ padding: '2em', paddingTop: 0, paddingBottom: '0em' }}
        >
          <Col span={8}>
            <FormItem label={<span>Slider Name</span>}>
              {this.props.form.getFieldDecorator('experienceNameSlider', {
                rules: [{ required: true, message: 'Site name is required' }],
                initialValue: this.props.editExperience
                  ? this.props.editExperience.experienceNameSlider
                  : ''
              })(<Input size="large" placeholder={'Please enter site name'} />)}
            </FormItem>
          </Col>{' '}
          <Col span={8}>
            <FormItem label={<span>Slider Decription</span>}>
              {this.props.form.getFieldDecorator(
                'experienceDescriptionSlider',
                {
                  rules: [{ required: true, message: 'Site name is required' }],
                  initialValue: this.props.editExperience
                    ? this.props.editExperience.experienceDescriptionSlider
                    : ''
                }
              )(<Input size="large" placeholder={'Please enter site name'} />)}
            </FormItem>
          </Col>{' '}
          <Col span={24} style={{ marginTop: '1em' }}>
            <FormItem label="Add products that will be showcased on this product slider">
              {this.props.form.getFieldDecorator('sliderProducts', {
                rules: [{ required: true, message: 'Supplier Name required' }],
                initialValue: this.props.editExperience
                  ? this.props.editExperience.sliderProducts
                  : undefined
              })(
                <Select
                  allowClear={false}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  mode="multiple"
                  size="large"
                  showSearch
                >
                  {this.props.stock.map(stock => (
                    <Option key={stock._id} value={stock._id}>
                      {stock.productTitle}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>
          </Col>
          <Col span={24} style={{ marginTop: '1em' }}>
            <FormItem label="Assign categories for slider to be displayed on">
              {this.props.form.getFieldDecorator('sliderCollection', {
                rules: [{ required: true, message: 'Supplier Name required' }],
                initialValue: this.props.editExperience
                  ? this.props.editExperience.sliderCollection
                  : undefined
              })(
                <Select mode="multiple" size="large" showSearch>
                  <Option key={'Homepage'} value={'Homepage'}>
                    Homepage
                  </Option>
                  {this.props.sites.map(item => (
                    <Option key={item._id} value={item._id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>
          </Col>
        </Row>
      </Form>
      </ResponsiveFormWrap>
    );
  }
}
const SliderForm = Form.create()(SliderFormClass);

class Experience extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedYear: dayjs().format('YYYY'),
      filteredExperience: [], // Filtered data for the table
      loading: false,
      closed: false,
      rejectReason: '',
      editExperience: undefined,
      siteSelected: resolveSelectedSite(
        this.props.selectedSite,
        this.props.sites
      ),
      activeKey: 'Experience', // Default active key
      size: 'large',
      flag: false,
      currentTab: 'All',
      selectedMonths: [dayjs().format('MM')]
    };
  }

  componentDidMount = async () => {
    this.setState({ loading: true, selectedYear: dayjs().format('YYYY') });

    try {
      await Promise.all([
        this.fetchAllExperience(),
        this.fetchAllSites(),
        this.fetchAllUsers()
      ]);

      this.filterData();

      this.setState({ loading: false });

      window.addEventListener('resize', this.resizeEvent);

      if (window.cordova) {
        document.addEventListener('backbutton', this.handleBack);
      }
    } catch (error) {
      console.error('Error during componentDidMount:', error);
      this.setState({ loading: false });
      Notify('error', 'Error', error.message || 'An error occurred');
    }
  };

  fetchAllExperience = () => {
    const { selectedYear, siteSelected, selectedMonths } = this.state;

    return this.props
      .findAllExperience(siteSelected, selectedYear, selectedMonths)
      .catch(error => {
        throw new Error(`Error fetching experience: ${error}`);
      });
  };

  fetchAllSites = () => {
    return this.props.findAllSites().catch(error => {
      throw new Error(`Error fetching sites: ${error}`);
    });
  };

  fetchAllUsers = () => {
    return this.props.findAllUsers().catch(error => {
      throw new Error(`Error fetching users: ${error}`);
    });
  };

  handleBack = () => {
    if (this.state.previewVisible) {
      this.setState({ previewVisible: false, previewVisibleVariant: false });
    } else {
      this.props.history.goBack();
    }
  };
  resizeEvent = () => {
    this.setState({ loading: false });
  };
  stopProp = e => {
    e.stopPropagation();
  };

  experienceForm;
  onAddExperience = e => {
    this.setState({ addExperienceVisible: true, editExperience: undefined });
  };

  onAddSlider = e => {
    this.setState({ addSliderVisible: true, editExperience: undefined });
  };

  handleMonthChange = date => {
    const selectedYear = date ? dayjs(date).format('YYYY') : null;

    this.setState({ selectedYear }, () => {
      this.fetchAllExperience().then(() => {
        this.filterData(); // âœ… Run after data and state update
      });
    });
  };

  handleAddExperience = e => {
    e.preventDefault();
    this.experienceForm.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.setState({ loading: true });
        values.mainExperienceImage1 = this.experienceForm.state.mainExperienceImage1;

        // Stamp the scale and questions this card was scored against, so the
        // record stays readable if the site later changes either.
        values.ratingScale = this.experienceForm.editCardScale();
        values.criteriaKeys = this.experienceForm
          .editCardCriteria()
          .map(c => c.key);

        if (this.state.editExperience) {
          values._id = this.state.editExperience._id;
        }
        this.props
          .addExperience(values)
          .then(() => {
            this.props
              .findAllExperience(
                this.state.siteSelected,
                this.state.selectedYear,
                this.state.selectedMonths
              )
              .then(() => {
                if (this.state.editExperience) {
                  Notify('success', 'Successfully saved');
                } else {
                  Notify('success', 'Successfully added');
                }
                this.experienceForm.props.form.resetFields();
                this.setState(
                  {
                    loading: false,
                    addExperienceVisible: false,
                    addSliderVisible: false,
                    editExperience: undefined,
                    currentTab: 'All'
                  },
                  this.filterData
                );
              })
              .catch(e => {
                this.setState({ loading: false });
                Notify('error', e);
              });
          })

          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
      }
    });
  };
  handleAddSlider = e => {
    e.preventDefault();
    this.sliderForm.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.setState({ loading: true });
        if (this.state.editExperience) {
          values._id = this.state.editExperience._id;
        }
        this.props
          .addExperience(values)
          .then(() => {
            this.props
              .findAllExperience(
                this.state.siteSelected,
                this.state.selectedYear,
                this.state.selectedMonths
              )
              .then(() => {
                if (this.state.editExperience) {
                  Notify('success', 'Successfully saved');
                } else {
                  Notify('success', 'Successfully added');
                }
                this.sliderForm.props.form.resetFields();
                this.setState({
                  loading: false,
                  addExperienceVisible: false,
                  addSliderVisible: false,
                  editExperience: undefined,
                  currentTab: 'All'
                });
              })
              .catch(e => {
                this.setState({ loading: false });
                Notify('error', e);
              });
          })

          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
      }
    });
  };

  handleEditExperience = e => {
    this.setState({ addExperienceVisible: true, editExperience: e });
  };
  handleEditSlider = e => {
    this.setState({ addSliderVisible: true, editExperience: e });
  };

  handleDeleteExperience = e => {
    e.preventDefault();
    const id = e.currentTarget.getAttribute('data');
    const { siteSelected, selectedYear, selectedMonths } = this.state;

    Modal.confirm({
      centered: true,
      title: 'Confirm delete',
      content: (
        <div>
          <h4>Are you sure you want to delete?</h4>
        </div>
      ),
      onCancel() {
        // no-op
      },
      onOk: async () => {
        this.setState({ loading: true });
        try {
          await this.props.deleteExperience(id);

          await this.props.findAllExperience(
            siteSelected,
            selectedYear,
            selectedMonths
          );

          Notify('success', 'Successfully deleted');

          // close spinner/modal, reset tab, then re-run filterData
          this.setState(
            {
              loading: false,
              currentTab: 'All'
            },
            this.filterData
          );
        } catch (err) {
          this.setState({ loading: false });
          Notify('error', err);
        }
      }
    });
  };

  handleDeleteSlider = e => {
    const id = e.currentTarget.getAttribute('data');
    var that = this;
    Modal.confirm({
      centered: true,
      content: (
        <div>
          <h4>Are you sure you want to delete?</h4>
        </div>
      ),
      onOk() {
        that.setState({ loading: true });
        that.props
          .deleteExperience(id)
          .then(() => {
            that.props
              .findAllExperience(
                this.state.siteSelected,
                this.state.selectedYear,
                this.state.selectedMonths
              )
              .then(() => {
                that.setState({ loading: false, currentTab: 'All' });
                // that.props.find140mm();
                // that.props.find171mm();
                Notify('success', 'Successfully deleted');
              })
              .catch(e => {
                that.setState({ loading: false });
                Notify('error', e);
              });
          })
          .catch(e => {
            that.setState({ loading: false });
            Notify('error', e);
          });
      },
      oncancel() {}
    });
  };

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      text ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        ''
      )
  });

  renderStatus = (status, color) => {
    return (
      <p style={{ margin: 0 }}>
        <StyledBadge color={color} style={{}} />
        {status}
      </p>
    );
  };

  changeTypeTab = key => {
    this.setState({ currentTab: key });
  };
  handleTabChange = key => {
    this.setState({ activeKey: key });
  };

  handleSearchName = () => {
    if (this.state.siteSelected.length > 0) {
      // this.handleSelectFocus();
      this.setState({ loading: true }); // Set loading state to true before API call
      this.props
        .findAllExperience(
          this.state.siteSelected,
          this.state.selectedYear,
          this.state.selectedMonths
        )
        .then(response => {
          const { stock, total } = response.data; // Destructure total from response
          this.setState({
            loading: false
            // stockData: stock, // Update stockData with fetched data
            // totalStock: total, // Set totalStock with the total count from the API
            // currentPage: 1, // Reset to the first page when fetching new data
          });
        })
        .catch(e => {
          this.setState({ loading: false });
          Notify('error', e.message);
        });
    }
  };

  exportToExcel = () => {
    const getColor = avg => {
      if (avg >= 75) return 'green';
      if (avg >= 50) return 'orange';
      return 'red';
    };

    const exportCriteria = this.activeCriteria();

    const flatData = this.state.filteredExperience
      .sort((a, b) => String(a.month).localeCompare(String(b.month)))
      .map(monthRecord => {
        // for each month we want one row per record
        return monthRecord.records.map(rec => {
          const scale = scaleOfRecord(rec);
          const row = {
            Month: dayjs(`${monthRecord.month}-01`).format('MMM YYYY'),
            Date: rec.timestamp ? dayjs(rec.timestamp).format('YYYY-MM-DD') : '',
            Room: rec.roomNumber
          };

          // One column per question the site asks, labelled as configured.
          exportCriteria.forEach(criterion => {
            const heading = criterion.retired
              ? `${criterion.label} (retired)`
              : criterion.label;
            const value = rec[criterion.key];

            if (isNA(value, scale)) {
              row[heading] = 'N/A';
              return;
            }
            const percent = toPercent(value, scale);
            row[heading] = percent === null ? '' : percent.toFixed(0) + '%';
          });

          row.memorablePart = rec.memorablePart;
          row.outstandingService = rec.outstandingService;
          row.recommendation = rec.recommendation;
          row.comments = rec.comments;
          return row;
        });
      })
      .flat();

    const ws = XLSX.utils.json_to_sheet(flatData);
    const range = XLSX.utils.decode_range(ws['!ref']);
    // 0) set custom column widths
    ws['!cols'] = [
      { wch: 12 }, // Month
      { wch: 12 }, // Date
      { wch: 8 }, // Room
      { wch: 14 }, // Friendliness
      { wch: 8 }, // Bar
      { wch: 8 }, // Waiter
      { wch: 10 }, // Breakfast
      { wch: 6 }, // Lunch
      { wch: 6 }, // Dinner
      { wch: 12 }, // Main Areas
      { wch: 10 }, // In-room
      { wch: 12 }, // Cleanliness
      { wch: 8 }, // Spa
      { wch: 50 }, // Cleanliness
      { wch: 50 }, // Cleanliness
      { wch: 50 }, // Cleanliness
      { wch: 50 } // Cleanliness
    ];
    // 1) style header row black
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cell = XLSX.utils.encode_cell({ r: 0, c: C });
      if (!ws[cell]) continue;
      ws[cell].s = {
        fill: { fgColor: { rgb: '000000' } },
        font: { color: { rgb: 'FFFFFF' }, bold: true },
        alignment: { horizontal: 'center', vertical: 'center' }
      };
    }

    // 2) build a lookup of headerâ†’column index
    const headerMap = {};
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const hdrCell = XLSX.utils.encode_cell({ r: 0, c: C });
      if (ws[hdrCell] && ws[hdrCell].v) headerMap[ws[hdrCell].v] = C;
    }

    // 3) define your colorâ€map and rating fields
    const colorMap = {
      green: '00FF00',
      orange: 'FFA500',
      red: 'FF0000'
    };
    const ratingFields = [
      'Friendliness',
      'Bar',
      'Waiter',
      'Breakfast',
      'Lunch',
      'Dinner',
      'Main Areas',
      'In-room',
      'Cleanliness',
      'Spa',
      'Memorable',
      'Service',
      'Recommendation',
      'Comments'
    ];

    // 4) iterate over each data row (r = 1..range.e.r)
    for (let r = range.s.r + 1; r <= range.e.r; ++r) {
      ratingFields.forEach(field => {
        const c = headerMap[field];
        if (c == null) return; // column not present?
        const addr = XLSX.utils.encode_cell({ r, c });
        const cell = ws[addr];
        if (!cell || !cell.v) return; // no value
        // strip the "%" and parse the number
        const num = parseInt(String(cell.v).replace('%', ''), 10);
        const colName = getColor(num); // "green"|"orange"|"red"
        const hex = colorMap[colName];
        // apply a background fill
        cell.s = {
          ...cell.s,
          fill: { fgColor: { rgb: hex } }
        };
      });
    }

    // 5) pack & write workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Report');
    XLSX.writeFile(wb, 'report.xlsx', { bookType: 'xlsx', cellStyles: true });
  };

  // The criteria to display for the selected site: whatever it asks now, plus
  // anything reviews were actually collected under, so changing a site's
  // questions never makes past scores disappear.
  activeCriteria = (records = null) => {
    const site = (this.props.sites || []).find(
      s => String(s._id) === String(this.state.siteSelected)
    );
    const source =
      records ||
      (this.props.experience || []).filter(item =>
        this.state.siteSelected
          ? String(item.access) === String(this.state.siteSelected)
          : true
      );
    return criteriaWithHistory(site, source);
  };

  groupExperienceData = experienceData => {
    const criteria = this.activeCriteria(experienceData);

    const groupedData = experienceData.reduce((acc, item) => {
      const monthKey = dayjs(item.timestamp).format('YYYY-MM');

      if (!acc[monthKey]) {
        acc[monthKey] = {
          month: monthKey,
          numberOfCards: 0,
          records: [],
          criteria
        };
        criteria.forEach(c => {
          acc[monthKey][`${c.key}Sum`] = 0;
          acc[monthKey][`${c.key}Count`] = 0;
        });
      }

      // Each review is scored against the scale it was captured on, so a site
      // that switched from 4 to 5 stars still averages its history correctly.
      // Percentages are accumulated rather than raw stars for the same reason â€”
      // 3/4 and 3/5 are not the same score.
      const scale = scaleOfRecord(item);
      criteria.forEach(c => {
        const percent = toPercent(item[c.key], scale);
        if (percent !== null) {
          acc[monthKey][`${c.key}Sum`] += percent;
          acc[monthKey][`${c.key}Count`] += 1;
        }
      });

      acc[monthKey].numberOfCards++;
      acc[monthKey].records.push(item);
      return acc;
    }, {});

    return Object.values(groupedData).map(month => {
      const avg = (sum, count) => (count > 0 ? sum / count : 0);
      const result = { ...month };

      const answered = [];
      criteria.forEach(c => {
        const value = avg(month[`${c.key}Sum`], month[`${c.key}Count`]);
        // Percent, 0-100. Kept under the historical `<key>Avg` name so the
        // table columns and export need no renaming.
        result[`${c.key}Avg`] = value;
        if (month[`${c.key}Count`] > 0) answered.push(value);
      });

      result.totalAvgScore = answered.length
        ? answered.reduce((s, v) => s + v, 0) / answered.length
        : 0;

      return result;
    });
  };

  filterData = () => {
    const { siteSelected } = this.state;
    const { experience } = this.props;

    const filteredExperience = experience.filter(item => {
      // Only filter by site (access), since month is handled server-side
      return siteSelected ? item.access === siteSelected : true;
    });

    const groupedExperienceData = this.groupExperienceData(filteredExperience);

    this.setState({ filteredExperience: groupedExperienceData });
  };

  qrRef = createRef();
  downloadQRCode = () => {
    const canvas = this.qrRef.current;
    if (canvas) {
      const url = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = url;
      link.download = 'QRCode.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.error('QR code canvas not found.');
    }
  };
  render() {
    const {
      activeKey,
      size,
      selectedYear,
      selectedDepartment,
      selectedResponsible,
      selectedStatus
    } = this.state;
    const qrCodeValue = `https://www.sproutmanagement.africa/rating/${this.state
      .siteSelected || 'default-site-id'}`;

    let descriptions = this.props.experience.map(experience => {
      return { value: experience.description };
    });
    const { experience } = this.props;
    let currentExperience;
    const filteredExperience = this.props.experience
      .filter(item => {
        const timestamp = item.timestamp
          ? dayjs(item.timestamp)
          : null;

        const matchesMonth = selectedYear
          ? timestamp && timestamp.format('YYYY-MM') === selectedYear
          : true; // Match year and month

        const matchesDepartment = selectedDepartment
          ? item.actionDepartment === selectedDepartment
          : true;

        const matchesResponsible = selectedResponsible
          ? item.actionResponsible === selectedResponsible
          : true;

        const matchesStatus = selectedStatus
          ? item.actionStatus === selectedStatus
          : true;

        const matchesSite = this.state.siteSelected
          ? item.access === this.state.siteSelected
          : true; // Ensure the item matches the selected site

        return (
          matchesMonth &&
          matchesDepartment &&
          matchesResponsible &&
          matchesStatus &&
          matchesSite
        );
      })
      .sort((a, b) => {
        const dateA = a.timestamp
          ? dayjs(a.timestamp)
          : dayjs.invalid();
        const dateB = b.timestamp
          ? dayjs(b.timestamp)
          : dayjs.invalid();

        // Handle invalid dates (push them to the end)
        if (!dateA.isValid() && !dateB.isValid()) return 0;
        if (!dateA.isValid()) return 1;
        if (!dateB.isValid()) return -1;

        // Sort by date in ascending order (earliest first)
        return dateA.diff(dateB);
      });

    const getColor = avg => {
      if (avg >= 75) return 'green';
      if (avg >= 50) return 'orange';
      return 'red';
    };

    // The questions this site asks, plus any it used to ask that still have
    // reviews attached. Everything below builds off this rather than a fixed
    // list of ten.
    const activeCriteria = this.activeCriteria();

    // groupExperienceData already stores <key>Avg as a percentage, so these
    // just average the monthly percentages.
    const calculateAverages = (data, fields) => {
      const result = {};
      fields.forEach(field => {
        const scored = data.filter(item => (item[field] || 0) > 0);
        const total = scored.reduce((sum, item) => sum + (item[field] || 0), 0);
        result[field] =
          scored.length > 0 ? (total / scored.length).toFixed(0) : 'N/A';
      });
      return result;
    };

    const ratingFields = [
      ...activeCriteria.map(c => `${c.key}Avg`),
      'totalAvgScore'
    ];
    const fieldTitleMap = activeCriteria.reduce(
      (acc, c) => {
        acc[`${c.key}Avg`] = c.retired ? `${c.label} (retired)` : c.label;
        return acc;
      },
      { totalAvgScore: 'Avg Score' }
    );

    // Calculate averages for the filtered data
    const averages = calculateAverages(
      this.state.filteredExperience,
      ratingFields
    );

    return (
      <div style={{ maxWidth: '90em', margin: 'auto' }}>
        <Spin spinning={this.state.loading}>
          {this.state.addExperienceVisible ? (
            <Cards
              bordered={false}
              extra={
                <Title
                  style={{
                    paddingRight: this.props.isMobile ? 0 : '75em',
                    fontSize: this.props.isMobile ? '17px' : '20px',
                    fontWeight: 800,
                    whiteSpace: this.props.isMobile ? 'normal' : 'nowrap',
                    fontFamily: 'Nunito'
                  }}
                >
                  {this.state.editExperience ? 'Edit Card' : 'Add Card'}
                  <p
                    style={{
                      fontWeight: 400,
                      fontSize: this.props.isMobile ? '13px' : '16px',
                      whiteSpace: this.props.isMobile ? 'normal' : 'nowrap',
                      marginTop: '0em',
                      marginBottom: '0em'
                    }}
                  >
                    {this.state.editExperience
                      ? 'Complete all required fields and click Save to publish'
                      : 'Complete all required fields and click Save to publish'}
                  </p>
                </Title>
              }
              style={{
                margin: 'auto',
                marginTop: '0em',
                backgroundColor: 'white',
                borderRadius: '0.8em',
                boxShadow: '0px 6px 15px 0px rgba(0, 0, 0, 0.08)'
              }}
            >
              <div
                style={{
                  // padding: '3em',
                  // paddingTop: '1em',
                  // paddingBottom: '4em',
                  margin: 'auto'
                }}
              >
                <ExperienceForm
                  sites={this.props.sites}
                  siteSelected={this.state.siteSelected}
                  stock={this.props.stock}
                  descriptions={descriptions}
                  editExperience={this.state.editExperience}
                  wrappedComponentRef={form => (this.experienceForm = form)}
                />{' '}
                {this.props.isMobile ? (
                  <MobileEditActions>
                    <Button
                      size="large"
                      icon={<StopFilled />}
                      onClick={() =>
                        this.setState({
                          addExperienceVisible: false,
                          editExperience: undefined
                        })
                      }
                    >
                      Cancel
                    </Button>
                    <Button
                      type="primary"
                      size="large"
                      icon={<CheckOutlined />}
                      onClick={this.handleAddExperience}
                    >
                      {this.state.editExperience ? 'Save Changes' : 'Save Card'}
                    </Button>
                  </MobileEditActions>
                ) : (
                  <FloatButton.Group
                    trigger="hover"
                    type="primary"
                    style={{ right: 24 }}
                    icon={<RocketFilled />}
                  >
                    <Tooltip placement="left" title="Save Item">
                      <FloatButton
                        onClick={this.handleAddExperience}
                        icon={<PlusCircleFilled style={{ color: '#80CE90' }} />}
                      />
                    </Tooltip>
                    <Tooltip placement="left" title="Cancel">
                      <FloatButton
                        onClick={e =>
                          this.setState({ addExperienceVisible: false })
                        }
                        icon={<StopFilled style={{ color: 'red' }} />}
                      />
                    </Tooltip>
                  </FloatButton.Group>
                )}
              </div>
            </Cards>
          ) : this.state.addSliderVisible ? (
            <Cards
              bordered={false}
              extra={
                <Title
                  style={{
                    paddingRight: this.props.isMobile ? 0 : '75em',
                    fontSize: this.props.isMobile ? '17px' : '20px',
                    fontWeight: 800,
                    whiteSpace: this.props.isMobile ? 'normal' : 'nowrap',
                    fontFamily: 'Nunito'
                  }}
                >
                  {this.state.editExperience ? 'Edit Slider' : 'Add Slider'}
                  <p
                    style={{
                      fontWeight: 400,
                      fontSize: this.props.isMobile ? '13px' : '16px',
                      whiteSpace: this.props.isMobile ? 'normal' : 'nowrap',
                      marginTop: '0em',
                      marginBottom: '0em'
                    }}
                  >
                    {this.state.editExperience
                      ? "Complete all fields and click 'Save' to showcase your slider"
                      : 'Present Your Products with an Engaging Product Slider'}
                  </p>
                </Title>
              }
              style={{
                margin: 'auto',
                marginTop: '0em',
                backgroundColor: 'white',
                borderRadius: '0.8em',
                boxShadow: '0px 6px 15px 0px rgba(0, 0, 0, 0.08)'
              }}
            >
              <div
                style={{
                  // padding: '3em',
                  // paddingTop: '1em',
                  // paddingBottom: '4em',
                  margin: 'auto'
                }}
              >
                <SliderForm
                  sites={this.props.sites}
                  stock={this.props.stock}
                  descriptions={descriptions}
                  editExperience={this.state.editExperience}
                  wrappedComponentRef={form => (this.sliderForm = form)}
                />{' '}
                <FloatButton.Group
                  trigger={this.props.isMobile ? 'click' : 'hover'}
                  type="primary"
                  style={{
                    right: 24
                  }}
                  icon={<RocketFilled />}
                >
                  <Tooltip placement="left" title="Save Item">
                    <FloatButton
                      onClick={this.handleAddSlider}
                      icon={<PlusCircleFilled style={{ color: '#80CE90' }} />}
                    />
                  </Tooltip>
                  <Tooltip placement="left" title="Cancel">
                    <FloatButton
                      onClick={e => this.setState({ addSliderVisible: false })}
                      icon={<StopFilled style={{ color: 'red' }} />}
                    />
                  </Tooltip>
                </FloatButton.Group>
              </div>
            </Cards>
          ) : (
            <>
              <Row gutter={[16, 12]}>
                <Col xs={24} lg={6}>
                  <h1
                    style={{
                      marginBottom: '0em',
                      marginRight: '1em',
                      fontSize: '22px',
                      fontWeight: 800,
                      fontFamily: 'Nunito',
                      marginTop: '0.3em'
                    }}
                  >
                    Guest Experience
                  </h1>
                </Col>
                <Col xs={24} lg={18}>
                  <ExperienceToolbar>
                  <Button
                    className="experience-export"
                    type="primary"
                    style={{
                      backgroundColor: 'black',
                      marginTop: '0.3em'
                    }}
                    onClick={this.exportToExcel}
                  >
                    <DownloadOutlined />
                  </Button>
                  <Button
                    className="experience-add"
                    type="primary"
                    onClick={this.onAddExperience}
                    icon={<PlusCircleFilled style={{ fontSize: '110%' }} />}
                    size="large"
                    style={{}}
                  >
                    Add Card
                  </Button>
                  <QRCodeCanvas
                    value={qrCodeValue}
                    size={350}
                    bgColor={'#ffffff'}
                    fgColor={'#000000'}
                    level={'H'}
                    includeMargin={true}
                    ref={this.qrRef}
                    style={{ display: 'none' }}
                  />

                  <Button
                    className="experience-qr"
                    type="primary"
                    icon={<QrcodeOutlined />}
                    size="large"
                    onClick={this.downloadQRCode}
                    style={{ width: this.props.isMobile ? '100%' : 100 }}
                  >
                    QR
                  </Button>
                  {/* Month Picker */}
                  <Select
                    className="experience-month"
                    // mode="multiple"
                    placeholder="Select Months"
                    size="large"
                    value={this.state.selectedMonths}
                    onChange={selectedMonths => {
                      if (selectedMonths.length === 0) {
                        message.warning(
                          'At least one month must remain selected.'
                        );
                        return;
                      }

                      this.setState(
                        { selectedMonths, loading: true },
                        async () => {
                          await this.fetchAllExperience();
                          this.filterData();
                          this.setState({ loading: false });
                        }
                      );
                    }}
                    style={{
                      width: this.props.isMobile ? '100%' : 300
                    }}
                  >
                    {Array.from({ length: 12 }, (_, i) => {
                      const monthValue = this.state.selectedYear
                        ? `${String(i + 1).padStart(2, '0')}`
                        : '';

                      return (
                        <Select.Option key={monthValue} value={monthValue}>
                          {dayjs()
                            .month(i)
                            .format('MMMM')}
                        </Select.Option>
                      );
                    })}
                  </Select>

                  <DatePicker
                    className="experience-year"
                    picker="year"
                    placeholder="Select Year"
                    format="YYYY"
                    value={
                      this.state.selectedYear
                        ? dayjs(`${this.state.selectedYear}-01-01`)
                        : null
                    }
                    onChange={date => {
                      const selectedYear = date
                        ? dayjs(date).format('YYYY')
                        : null;
                      this.setState(
                        {
                          selectedYear,
                          selectedMonths: [dayjs().format('MM')]
                        },
                        () => {
                          this.fetchAllExperience().then(() =>
                            this.filterData()
                          );
                        }
                      );
                    }}
                    allowClear={false}
                    size="large"
                    style={{ width: this.props.isMobile ? '100%' : 100 }}
                  />

                  <Select
                    className="experience-site"
                    size="large"
                    value={this.state.siteSelected} // Bind selected value to state
                    showSearch
                    onChange={value => {
                      this.props.setSelectedSite(value);
                      this.setState({ siteSelected: value }, () => {
                        this.fetchAllExperience().then(() => this.filterData());
                      });
                    }}
                    style={{
                      width: this.props.isMobile ? '100%' : '12em'
                    }}
                    placeholder="Select Company"
                    optionFilterProp="children"
                  >
                    {/* <Select.Option key="Admin" value="Admin">
                      Admin
                    </Select.Option> */}
                    {this.props.sites.map(site => (
                      <Select.Option key={site._id} value={site._id}>
                        {site.name}
                      </Select.Option>
                    ))}
                  </Select>
                  </ExperienceToolbar>
                </Col>
              </Row>
              <ExperienceAverages>
                {Object.entries(averages).map(([field, value]) => (
                  <Tag
                    color={value === 'N/A' ? 'default' : getColor(value)}
                    key={field}
                    style={{ fontSize: 14, padding: 6, marginTop: '0.5em' }}
                  >
                    {fieldTitleMap[field] || field}: {value}{value !== 'N/A' ? '%' : ''}
                  </Tag>
                ))}
              </ExperienceAverages>
              <Row>
                <Col span={24}>
                  <MobileTableHelp>
                    <strong>SWIPE</strong>
                    Swipe sideways for scores. Tap + to open guest cards.
                  </MobileTableHelp>
                  <StyledTable
                    bordered={false}
                    dataSource={this.state.filteredExperience.sort((a, b) => {
                      return String(a.month).localeCompare(String(b.month));
                    })}
                    rowKey="month"
                    size="middle"
                    pagination={false}
                    scroll={
                      this.props.isMobile ? { x: 'max-content' } : undefined
                    }
                    style={{
                      minWidth: '15em',
                      marginTop: '1em'
                    }}
                    expandable={{
                      expandedRowRender: record => (
                        <StyledTable
                          bordered={false}
                          scroll={
                            this.props.isMobile
                              ? { x: 'max-content' }
                              : undefined
                          }
                          dataSource={record.records.sort((a, b) => {
                            const dateA = a.timestamp
                              ? dayjs(a.timestamp)
                              : null;
                            const dateB = b.timestamp
                              ? dayjs(b.timestamp)
                              : null;

                            // Handle invalid or null dates
                            if (!dateA && !dateB) return 0;
                            if (!dateA) return 1;
                            if (!dateB) return -1;

                            return dateA.diff(dateB); // Ascending order
                          })}
                          rowKey="_id"
                          size="small"
                          pagination={false}
                        >
                          {/* Columns for individual records */}
                          <Column
                            title="Date"
                            dataIndex="timestamp"
                            key="timestamp"
                            render={text =>
                              text
                                ? dayjs(text).format('YYYY-MM-DD')
                                : 'No Date'
                            } // Format date as "YYYY-MM-DD"
                          />
                          {/* <Column title="Full Name" dataIndex="fullName" key="fullName" /> */}
                          <Column
                            title="Room Number"
                            dataIndex="roomNumber"
                            key="roomNumber"
                          />
                          {/* One column per question the site asks, plus any
                              retired question that still has answers. Each
                              review is scored against the scale it was
                              captured on. */}
                          {activeCriteria.map(criterion => (
                            <Column
                              key={criterion.key}
                              title={
                                criterion.retired
                                  ? `${criterion.label} (retired)`
                                  : criterion.label
                              }
                              dataIndex={criterion.key}
                              render={(text, exp) => {
                                const scale = scaleOfRecord(exp);
                                if (isNA(text, scale)) return <Tag>N/A</Tag>;
                                const percent = toPercent(text, scale);
                                if (percent === null) return <Tag>-</Tag>;
                                return (
                                  <Tag color={getColor(percent)}>
                                    {percent.toFixed(0)}%
                                  </Tag>
                                );
                              }}
                            />
                          ))}
                          <Column
                            title="Avg. Score"
                            key="avgScore"
                            render={(_, exp) => {
                              const scale = scaleOfRecord(exp);
                              // Average the percentages so a card captured on a
                              // different scale still compares like for like.
                              const scored = activeCriteria
                                .map(c => toPercent(exp[c.key], scale))
                                .filter(p => p !== null);
                              if (!scored.length) return <Tag>N/A</Tag>;
                              const avgPercent =
                                scored.reduce((s, p) => s + p, 0) /
                                scored.length;
                              return (
                                <Tag color={getColor(avgPercent)}>
                                  {avgPercent.toFixed(0)}%
                                </Tag>
                              );
                            }}
                          />
                          <Column
                            title="Actions"
                            fixed={this.props.isMobile ? 'right' : undefined}
                            width={96}
                            render={(text, experience) => (
                              <span>
                                <EditFilled
                                  style={{
                                    backgroundColor: '#80CE90',
                                    color: 'white',
                                    padding: '0.5em',
                                    borderRadius: '3em'
                                  }}
                                  onClick={e =>
                                    this.handleEditExperience(experience)
                                  }
                                />
                                <Divider type="vertical" />
                                <Tooltip placement="top" title="Delete Sale">
                                  <DeleteFilled
                                    style={{
                                      backgroundColor: 'crimson',
                                      color: 'white',
                                      padding: '0.5em',
                                      borderRadius: '3em'
                                    }}
                                    data={experience._id}
                                    onClick={this.handleDeleteExperience}
                                  />
                                </Tooltip>
                              </span>
                            )}
                          />
                        </StyledTable>
                      )
                    }}
                  >
                    <Column
                      title="Month"
                      dataIndex="month"
                      key="month"
                      render={month => dayjs(month).format('MMM YYYY')}
                    />
                    {/* Monthly averages. groupExperienceData stores these as
                        percentages already, so no scale maths here. */}
                    {activeCriteria.map(criterion => (
                      <Column
                        key={`${criterion.key}Avg`}
                        title={
                          criterion.retired
                            ? `${criterion.label} (retired)`
                            : criterion.label
                        }
                        dataIndex={`${criterion.key}Avg`}
                        render={text =>
                          !text ? (
                            <Tag>N/A</Tag>
                          ) : (
                            <Tag color={getColor(text)}>
                              {text.toFixed(0)}%
                            </Tag>
                          )
                        }
                      />
                    ))}
                    <Column
                      title="Total Avg Score"
                      dataIndex="totalAvgScore"
                      key="totalAvgScore"
                      render={text =>
                        !text ? (
                          <Tag>N/A</Tag>
                        ) : (
                          <Tag color={getColor(text)}>{text.toFixed(0)}%</Tag>
                        )
                      }
                    />
                    <Column
                      title="Number of Cards"
                      dataIndex="numberOfCards"
                      key="numberOfCards"
                    />
                  </StyledTable>
                </Col>
              </Row>
            </>
          )}
        </Spin>
      </div>
    );
  }
}

const WrappedExperience = Form.create()(withIsMobile(Experience));
export default WrappedExperience;
